import React, { useState, useEffect } from "react";
import { getCategories } from "../../api/products";
import { useNavigate } from "react-router-dom";

const DEFAULT = "/images/DEFAULT.png";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // 이름과 대표 이미지를 함께 쓰므로 API 응답 객체를 그대로 보관한다
    const fetchCategories = async () => {
      const categoriesData = await getCategories();
      setCategories(categoriesData);
    };
    
    fetchCategories();
  }, []);

  const handleSelectCategory = (category) => {
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  return (
    <div className="w-full mt-4 px-4 md:px-[160px] lg:px-[200px]">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {categories.map(({ category, image_url }) => (
          <button
            key={category}
            onClick={() => handleSelectCategory(category)}
            className="border p-4 rounded-xl shadow flex flex-col justify-between w-full aspect-square bg-white"
          >
            <h3 className="mb-3 text-lg md:text-lg lg:text-2xl font-semibold text-start text-gray-950">{category}</h3>
            <img
              src={image_url || DEFAULT }
              alt={category}
              className="w-full object-contain"
              onError={(e) => {
                e.target.src = DEFAULT;
              }
            }
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
